import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/query-keys';
import { financialService } from '../../services/financial.service';

export function useChangeOrders(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.changeOrders.all(orgId ?? ''),
    queryFn: () => financialService.getBudgetChangeOrders(orgId!),
    enabled: !!orgId,
    staleTime: 30_000,
    select: (res: any) => Array.isArray(res.data) ? res.data : [],
  });
}
